"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseEnrollments = void 0;
const sdk_1 = require("../sdk");
var CourseEnrollments;
(function (CourseEnrollments) {
    CourseEnrollments.list = (options) => {
        const url = '/course-enrollments';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    CourseEnrollments.get = (courseEnrollmentId) => {
        const url = `/course-enrollments/${courseEnrollmentId}`;
        return sdk_1.SDK.axios.get(url);
    };
})(CourseEnrollments = exports.CourseEnrollments || (exports.CourseEnrollments = {}));
//# sourceMappingURL=course-enrollments.js.map